export default __webpack_public_path__ + "c11abb88a57c3790950cb883d9ee4459.svg";